import { axiosInstance } from "@/api/axios";
import { LoginParams, LoginResponse } from "@/types/auth";

export const login = async ({
  username,
  password,
}: LoginParams): Promise<LoginResponse> => {
  const formData = new URLSearchParams();
  formData.append("username", username);
  formData.append("password", password);

  const { data } = await axiosInstance.post<LoginResponse>(
    "/auth/login",
    formData,
    {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      withCredentials: true, // for cookies
    }
  );

  return data;
};

export const logout = async (): Promise<void> => {
  await axiosInstance.post(
    "/auth/logout",
    {},
    {
      withCredentials: true,
    }
  );
};
